import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
// var $ = require("jquery");

import VueI18n from "vue-i18n";

// Importing JSON files
import enLocale from "./locales/en.json";
import frLocale from "./locales/fr.json";
import arLocale from "./locales/ar.json";

Vue.use(VueI18n);

import "./app.css";
import "./axios-interceptor"; // Import the interceptor file

import DashboardAdmin from "./layouts/DashboardAdmin.vue";
import Default from "./layouts/Default.vue";
import Login from "./layouts/Login.vue";
import DataTable from "./components/cards/DataTable.vue";
import VueSelect from "./components/cards/VueSelect.vue";
import VueConfirmDialog from "./components/cards/VueConfirmDialog.vue";

import VueActionButtons from "./components/cards/VueActionButtons.vue";
import VueFilterCard from "./components/cards/FilterCard.vue";

import OrderDetailsCard from "./components/cards/OrderDetailsCard.vue";
import DeliveryDetailsCard from "./components/cards/DeliveryDetailsCard.vue";
import CheckDetailsCard from "./components/cards/CheckDetailsCard.vue";

import PieChart from "./components/chart/PieChart.vue";

import confirm from "./plugins/confirm";
import loading from "./plugins/loading";
import toast from "./plugins/toast";
import axiosPlugin from "./plugins/axios";
import ModalPlugin from "./plugins/modal";
import download from "./plugins/download";
import imageUrlPlugin from "./plugins/imageUrl";
import pusherPlugin from "./plugins/pusher";
import constant from "./constant";

Vue.use(confirm);
Vue.use(loading);
Vue.use(toast);
Vue.use(axiosPlugin);
Vue.use(ModalPlugin);
Vue.use(download);
Vue.use(imageUrlPlugin);
Vue.use(pusherPlugin);

Vue.mixin({
  beforeCreate() {
    if (this.$options.store) {
      this.$options.store.$api = this.$api;
    }
  },
});

Object.defineProperty(Vue.prototype, "$userRole", {
  get() {
    return store.getters["auth/getUserRole"] || "";
  },
});
// Make settings globally accessible via Vue prototype
// Convert settings array to object for easy access (reactive)
Object.defineProperty(Vue.prototype, "$settings", {
  get() {
    return store.getters["auth/allSettings"] || {};
  },
});

// Also keep the array version available
Object.defineProperty(Vue.prototype, "$settingsArray", {
  get() {
    return store.getters["setting/getSettings"] || [];
  },
});

// Loop through all settings and dynamically add them to Vue.prototype (reactive)
// This uses getters so it's automatically reactive
const settings = store.getters["auth/allSettings"] || {};
Object.keys(settings).forEach((key) => {
  Object.defineProperty(Vue.prototype, `$${key}`, {
    get() {
      const allSettings = store.getters["auth/allSettings"];
      return allSettings && allSettings[key] ? allSettings[key] : null;
    },
    configurable: true,
  });
});

Object.defineProperty(Vue.prototype, "$setting", {
  get() {
    return (key) => store.getters["auth/getSetting"](key);
  },
});

// import { toFixedWithSpace } from "./filters";
// Vue.prototype.$toFixedWithSpace = toFixedWithSpace;
// Vue.filter("toFixedWithSpace", toFixedWithSpace);

Vue.config.productionTip = false;

Vue.component("layout-dashboard", DashboardAdmin);
Vue.component("layout-default", Default);
Vue.component("layout-login", Login);
Vue.component("vue-data-table", DataTable);
Vue.component("vue-select", VueSelect);
Vue.component("vue-confirm-dialog", VueConfirmDialog);
Vue.component("vue-action-buttons", VueActionButtons);
Vue.component("vue-filter-card", VueFilterCard);

Vue.component("vue-order-details", OrderDetailsCard);
Vue.component("vue-delivery-details", DeliveryDetailsCard);
Vue.component("vue-check-details", CheckDetailsCard);

Vue.component("vue-pie-chart", PieChart);

Vue.component("vueInternetChecker", require("vue-internet-checker"));

window.axios = require("axios");
// axios.defaults.baseURL = "http://localhost:8081";
// axios.defaults.withCredentials = true;
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

const token = localStorage.getItem(constant.authToken);
axios.defaults.headers.common["Authorization"] =
  "Bearer " + String(token).replaceAll('"', "");

window.addEventListener("storage", (event) => {
  if (event.key === constant.userRoleKey) {
    store.commit("SET_USER_ROLE", event.newValue);
  }
});

const messages = {
  en: enLocale,
  fr: frLocale,
  ar: arLocale,
};

const i18n = new VueI18n({
  locale: "fr", // Set the default locale
  fallbackLocale: "fr", // Set the fallback locale in case the current locale is not found
  messages,
});

new Vue({
  router,
  store,
  i18n,
  computed: {
    authData() {
      return this.$store.getters["auth/getAuthData"];
    },
  },
  async created() {
    // Load settings if user is authenticated
    const token = localStorage.getItem(constant.authToken);
    if (token) {
      try {
        // Load settings from API to sync with backend
        await store.dispatch("setting/getAll");
        // Also ensure auth settings are synced
        const settings = store.getters["setting/getSettings"] || [];
        if (settings && settings.length > 0) {
          store.commit("auth/SET_SETTINGS", settings);
        }
      } catch (error) {
        console.warn("Could not load settings on startup:", error);
      }
    }
    // Initialize Pusher when user is authenticated
    this.initializePusher();
  },
  watch: {
    // Watch computed property instead of getter path
    authData: {
      handler(authData) {
        if (authData && (authData.id || authData.reference)) {
          this.initializePusher();
        } else {
          if (this.$pusher) {
            this.$pusher.disconnect();
          }
          this.$store.dispatch("notification/setPusherConnected", false);
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    initializePusher() {
      const authData = this.$store.getters["auth/getAuthData"];
      const userId =
        (authData && authData.id) || (authData && authData.reference);
      if (!authData || !userId) {
        return;
      }

      try {
        // Initialize Pusher with user ID for private channels
        this.$pusher.init(userId);

        // Listen to public notifications
        this.$pusher.listen((data) => {
          this.handleNotification(data);
        });

        // Listen to private notifications
        this.$pusher.listenPrivate((data) => {
          this.handleNotification(data);
        });

        // Update connection status
        const pusherInstance = this.$pusher.getInstance();
        if (pusherInstance) {
          pusherInstance.connection.bind("connected", () => {
            this.$store.dispatch("notification/setPusherConnected", true);
          });

          pusherInstance.connection.bind("disconnected", () => {
            this.$store.dispatch("notification/setPusherConnected", false);
          });
        }

        this.$store.dispatch("notification/setPusherConnected", true);
      } catch (error) {
        console.error("Error initializing Pusher:", error);
      }
    },
    handleNotification(data) {
      // Add notification to store
      this.$store.dispatch("notification/addNotification", {
        message: data.message,
        type: data.type || "info",
        data: data.data || {},
      });

      // Show toast notification
      const toastMethod = this.$toast[data.type] || this.$toast.info;
      toastMethod(data.message);
    },
  },
  render: (h) => h(App),
}).$mount("#app");
